import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '85px',
    width: '85px',
    backgroundColor: '#E1F3E0',
    borderRadius: '50%',
  },
  icon: {
    display: 'block',
    margin: '0 auto',
    fontSize: '60px',
    color: 'green',
  },
  headline: {
    maxWidth: '70ch',
  },
  body: {
    maxWidth: '70ch',
    fontSize: theme.typography.h6.fontSize,
    lineHeight: 1.6,
  },
}));
